import {useState, useEffect} from 'react';
import {addLabelToArray, isStage} from '../helpers';
import {useApi, usePageValue} from '../context';

export function useBant(props) {
    let api = useApi();

    const [isLoading, setIsLoading] = useState(true);
    const [bant, setBant] = useState([]);
    const [hasError, setHasError] = useState(false);

    useEffect(() => {
        
        const fetchData = async() => {
            setIsLoading(true)
            let results = null;

                results = await api.getBantMetric(props.leadId);
          
            if(results.statusCode === 200) {
                let {data, message} = results;

                    // let labelledData = (addLabelToArray(data));
                    setBant(data[0])
              
            } 
            else {
                let {error} = results;
                setHasError(error);
            }
            // setIsLoading(false);
        }

        fetchData();
        return () => { 
            return [bant, isLoading, hasError ]
        }
    }, [props.substageId])

    return {bant, isLoading, hasError}
}